import React, { useContext, useState } from 'react'
import _uniqueId from 'lodash/uniqueId'
import { Icon } from '@bhvr/web-design-system'

import { NavContext } from './nav'
import Link from './nav-link'

const NavItem = (props) => {
  const { subOpen, activeSub, mobileOpen } = useContext(NavContext)
  const [isSubOpen, setIsSubOpen] = subOpen
  const [isActiveSub, setActiveSub] = activeSub
  const [isMobileOpen, setIsMobileOpen] = mobileOpen
  const [menuID] = useState(_uniqueId('nav-item-'))

  // Submenu Click Handler
  const clickEvent = e => {
    // Look if a subnav is currently open
    if (isSubOpen === false) {
      // Nothing is open, open the current subNav
      setIsSubOpen(true)
      setActiveSub(menuID)
    } else {
      if (isActiveSub !== menuID) {
        // Open new subnav
        setIsSubOpen(true)
        setActiveSub(menuID)
      } else {
        // Close the current subnav
        setIsSubOpen(false)
        setActiveSub(null)
      }
    }
  }

  const closeNav = e => {
    if (isSubOpen !== false) {
      setIsSubOpen(false)
      setActiveSub(null)
    }

    // Close mobile menu if direct link
    if (props.href !== '') {
      setIsMobileOpen(false)
    }
  }

  const childrenWithProps = React.Children.map(props.children, child => {
    return React.cloneElement(child, {
      menuid: menuID,
      label: props.title
    })
  })

  return (
    <li
      className={`${props.className}`}
      key={menuID}
      id={props.id}
      menu-id={menuID}
      role="none"
      onClick={props.trigger && props.trigger === 'click' ? clickEvent : null}
      onMouseOver={props.trigger && props.trigger === 'hover' ? clickEvent : null}
      onMouseLeave={props.trigger && props.trigger === 'hover' ? clickEvent : null}
    >
      {props.trigger && props.trigger !== null && props.trigger !== 'none' ? (
        // Empty parent link with sub-nav
        <>
          <a
            role="menuitem"
            tabIndex={props.tabIndex}
            aria-expanded={`${isActiveSub === menuID ? 'true' : 'false'}`}
            className={props.linkClasses}
          >
            {props.icon &&
              <Icon
                src={props.icon}
                title={props.icon.alternativeText}
                className={props.iconClass}
              />
            }
            {props.title &&
              <span>{props.title}</span>
            }
            {props.subNavIndicator &&
              <span className="subnav-indicator">
                <Icon
                  src={props.subNavIndicator}
                />
              </span>
            }
          </a>
          {childrenWithProps}
        </>
      ) : (
        (props.href && props.href !== null) || (props.anchor && props.anchor !== null) ? (
          // Direct Link or Anchor
          <Link
            anchor={props.anchor ? props.anchor : null}
            to={props.href ? props.href : null}
            role="menuitem"
            target={props.target}
            rel={props.target === '_blank' && !props.anchor ? 'noopener noreferrer' : undefined}
            tabIndex={props.tabIndex}
            className={props.linkClasses}
            activeClassName={props.disableAutoActive ? 'current' : ''}
            onClick={closeNav}
            trackClick={props}
          >
            <div className="nav-link-title">
              {props.icon &&
                <Icon
                  src={props.icon}
                  title={props.icon.alternativeText}
                  className={props.iconClass}
                />
              }
              <span>{props.title}</span>
            </div>
            {props.children && props.children !== null && (
              <div className="nav-link-content">
                {childrenWithProps}
              </div>
            )}
          </Link>
        ) : (
          <div className={props.linkClasses}>
            <div
              className="nav-link-title"
              onClick={closeNav}
            >
              {props.icon &&
                <Icon
                  src={props.icon}
                  title={props.icon.alternativeText}
                  className={props.iconClass}
                />
              }
              <span>{props.title}</span>
            </div>
            {props.children && props.children !== null && (
              <div className="nav-link-content">
                {childrenWithProps}
              </div>
            )}
          </div>
        )
      )}
    </li>
  )
}
export default NavItem
